var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.19249e-07C15.5228 5.33895e-08 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 1.85108e-07 15.5228 1.19249e-07 10C5.33895e-08 4.47715 4.47715 1.85108e-07 10 1.19249e-07ZM9.25 7.81066L7.53033 9.53033C7.23744 9.82322 6.76256 9.82322 6.46967 9.53033C6.17678 9.23744 6.17678 8.76256 6.46967 8.46967L8.76256 6.17678C9.44598 5.49336 10.554 5.49336 11.2374 6.17678L13.5303 8.46967C13.8232 8.76256 13.8232 9.23744 13.5303 9.53033C13.2374 9.82322 12.7626 9.82322 12.4697 9.53033L10.75 7.81066L10.75 14C10.75 14.4142 10.4142 14.75 10 14.75C9.58579 14.75 9.25 14.4142 9.25 14L9.25 7.81066Z",
    fill: "#BAEAC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.4ef09ab1442ead9c3f946196b76db093.svg";
export { ForwardRef as ReactComponent };